var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"join-request-node p-2 text-center"},[_c('a-card',{attrs:{"size":"small"}},[_vm._v(" "+_vm._s(_vm.i18n.t('flow_action_sidebar_delete_last_message_action_action_title'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }